/* LEET: бутонът за плащане в количката (страничната и страницата) води към междинния чекаут /cart?view=checkout вместо директно към Shopify checkout.
   Извадено от leet-ui.js (функция checkoutRoute). Зарежда се на всички страници: {{ 'leet-checkout-route.js' | asset_url | script_tag }} */
(function () {
  if (window._ltCoRoute) return;
  window._ltCoRoute = 1;
  if (/[?&]view=checkout\b/.test(location.search)) return;
  var url = ((window.routes && window.routes.cart_url) || '/cart') + '?view=checkout';
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href$="/checkout"]') : null;
    if (!t || t.disabled) return;
    e.preventDefault(); e.stopImmediatePropagation();
    t.classList.add('loading');
    window.location.href = url;
  }, true);

  /* полето „код за отстъпка“ в количката: темата праща към /checkout?discount=КОД и прескача междинния чекаут.
     Тук кодът се добавя към количката и страницата се презарежда с видимата отстъпка. */
  var JH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('cart-discount-form')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var inp = f.querySelector('[name="cart-discount-field"]'), err = f.querySelector('.cart-discount-form__error'), btn = f.querySelector('button');
    var code = inp ? String(inp.value || '').trim() : '';
    var msg = function (t) { if (err) { err.textContent = t; err.style.display = 'block'; } if (btn) { btn.disabled = false; btn.classList.remove('loading'); } };
    if (!code) { msg('Моля въведете код за отстъпка'); return; }
    if (err) err.style.display = 'none';
    if (btn) { btn.disabled = true; btn.classList.add('loading'); }
    var up = code.toUpperCase(), keep = [];
    var setCodes = function (list) { return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: JH, body: JSON.stringify({ discount: list.join(',') }) }).then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); }); };
    fetch('/cart.js?_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        keep = (c.discount_codes || []).filter(function (x) { return x.applicable && String(x.code).toUpperCase() !== up; }).map(function (x) { return x.code; });
        return setCodes(keep.concat([code]));
      })
      .then(function (c) {
        var hit = (c.discount_codes || []).filter(function (x) { return String(x.code).toUpperCase() === up; })[0];
        if (hit && hit.applicable) { window.location.reload(); return; }
        return setCodes(keep).catch(function () {}).then(function () { msg('Кодът „' + code + '“ не е валиден или не важи за тази поръчка.'); });
      })
      .catch(function () { msg('Нещо се обърка. Опитай пак.'); });
  }, true);
})();
